// extracted by mini-css-extract-plugin
export default {"searchPanel":"WSSearchPanel-module_searchPanel-EObHD","inputContainer":"WSSearchPanel-module_inputContainer-fp9lb","backButton":"WSSearchPanel-module_backButton-pwMfP"};